<mat-toolbar>
  <span>Accueil</span>
  <span class="spacer"></span>
  <span class="spacer"></span>
</mat-toolbar>
<div class="content">
  <p class="title-informations">
    {{ bonjourString }} <span class="highlight">{{ firstname }}</span
  >
   @if (activiteAdherent == 'gpo') {
  <span class="reset"> {{ bienvenueStringGPO }} </span>
   } @else {
  <span class="reset"> {{ bienvenueString }} </span>
   }
  </p>
  <div class="row">
    <div class="col">
      @if (linkToPageButtonsPilotage!.length > 0) {
        <app-button-link-list
          [linkToPageButtons]="linkToPageButtonsPilotage"
          [title]="PilotageString"
          [user]="user"
        ></app-button-link-list>
      }
      @if (linkToPageButtonsSuiviConditionsCommerciales!.length > 0) {
        <app-button-link-list
          [linkToPageButtons]="linkToPageButtonsSuiviConditionsCommerciales"
          [title]="SuiviConditionsCommercialesString"
          [user]="user"
        ></app-button-link-list>
      }
      @if (linkToPageButtonsAnimationsCommerciales!.length > 0) {
        <app-button-link-list
          [linkToPageButtons]="linkToPageButtonsAnimationsCommerciales"
          [title]="AnimationCommercialesString"
          [user]="user"
        ></app-button-link-list>
      }
    </div>
    <div class="col">
      @if (externalLinkButtons!.length > 0) {
        <app-button-link-list
          [linkToPageButtons]="externalLinkButtons"
          [title]="autresOutilsString"
          [user]="user"
        ></app-button-link-list>
      }
      @if (linkToPageButtonsAdmin!.length > 0) {
        <app-button-link-list
          [linkToPageButtons]="linkToPageButtonsAdmin"
          [title]="adminString"
          [user]="user"
        ></app-button-link-list>
      }
    </div>
  </div>
</div>
